import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { usersConstants } from "../..";

const initialState = {
	error: null,
	filtersApplied: {},
	filters: {},
	queryParams: {
		pageIndex: 0,
		sortBy: "agentOffice",
		isDescending: true,
	},
	activeUserId: null,
};

export const getUsersState = state => state.users;

function users(state = initialState, action) {
	switch (action.type) {
		case usersConstants.ADD_USER_SUBMIT_REQUEST:
			return {
				...state,
				loading: true,
			};
		case usersConstants.ADD_USER_SUBMIT_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case usersConstants.ADD_USER_SUBMIT_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case usersConstants.UPDATE_GENERAL_INFO_REQUEST:
			return {
				...state,
				loading: true,
			};
		case usersConstants.UPDATE_GENERAL_INFO_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case usersConstants.UPDATE_GENERAL_INFO_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case usersConstants.UPDATE_LINKS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case usersConstants.UPDATE_LINKS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case usersConstants.UPDATE_LINKS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case usersConstants.EDIT_USER_SUBMIT_REQUEST:
			return {
				...state,
				loading: true,
			};
		case usersConstants.EDIT_USER_SUBMIT_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case usersConstants.EDIT_USER_SUBMIT_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case usersConstants.SET_ACTIVE_USER_ID:
			return fp.set("activeUserId", action.id, state);
		default:
			return state;
	}
}

export default withResetState({ initialState })(users);
